import { useCallback } from 'react'
import { appStore, useAppDispatch, useAppSelector } from '@/store'
import { setDrawer } from '@/store/app'
import type { DrawerType } from '@/store/app'

export const useDrawer = () => {
  const dispatch = useAppDispatch()
  const { drawerOpened } = useAppSelector(appStore)

  const showDrawer = useCallback(
    (name: DrawerType) => {
      dispatch(setDrawer(name))
    },
    [dispatch]
  )

  const hideDrawer = useCallback(() => {
    dispatch(setDrawer(null))
  }, [dispatch])

  return { drawerOpened, showDrawer, hideDrawer }
}
